var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoVoopter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "340 142 145 38.183",
    width: "210px",
    height: "55px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#00688d;}.a,.b,.c{fill-rule:evenodd;}.b{fill:#00a9d6;}.c{fill:#00daff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(340 142)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M177.1,30.075a6.988,6.988,0,0,0-2.27-5.177,6.789,6.789,0,0,0-4.6-1.8,6.928,6.928,0,0,0-6.874,6.98v3.489a6.928,6.928,0,0,0,6.874,6.98,6.856,6.856,0,0,0,5.953-3.49l-.005-.006a1.809,1.809,0,0,0-.651-2.418,1.668,1.668,0,0,0-2.317.679,3.428,3.428,0,0,1-6.413-1.745V32.7h8.587a1.735,1.735,0,0,0,1.722-1.745v-.876Zm-10.2-.869a3.452,3.452,0,0,1,3.33-2.62,3.416,3.416,0,0,1,2.813,1.486,3.382,3.382,0,0,1,.512,1.134H166.9Z",
    transform: "translate(-42.391 -5.993)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M123.434,30.075a6.873,6.873,0,1,0-13.744,0v3.489a6.873,6.873,0,1,0,13.744,0Zm-3.435,0v3.489a3.437,3.437,0,1,1-6.874,0V30.075a3.437,3.437,0,1,1,6.874,0Z",
    transform: "translate(-28.465 -5.993)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M144.288,30.075a6.873,6.873,0,1,0-13.744,0V42.289a1.718,1.718,0,1,0,3.435,0V39.612a6.793,6.793,0,0,0,3.44.933,6.927,6.927,0,0,0,6.869-6.98Zm-3.434,0v3.489a3.438,3.438,0,1,1-6.875,0V30.075a3.438,3.438,0,1,1,6.875,0Z",
    transform: "translate(-33.876 -5.993)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M72.344,38.3a1.732,1.732,0,0,0,3.146,0L83.477,20.9a1.75,1.75,0,0,0-.83-2.315,1.7,1.7,0,0,0-2.282.84L73.917,33.464,67.474,19.43a1.707,1.707,0,0,0-2.288-.84,1.756,1.756,0,0,0-.829,2.315Z",
    transform: "translate(-16.659 -4.781)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M154.426,20.13a1.718,1.718,0,1,0-3.435,0v1.745a1.745,1.745,0,0,0,0,3.491v6.979a6.927,6.927,0,0,0,6.869,6.98,1.745,1.745,0,0,0,0-3.49,3.462,3.462,0,0,1-3.434-3.49V25.365h3.434a1.746,1.746,0,0,0,0-3.491h-3.434V20.13Z",
    transform: "translate(-38.735 -4.772)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M191.086,23.1a6.787,6.787,0,0,0-3.591,1.031,1.716,1.716,0,0,0-1.561-1.031,1.736,1.736,0,0,0-1.723,1.745V38.8a1.72,1.72,0,1,0,3.44,0V30.075a3.466,3.466,0,0,1,3.434-3.49,1.745,1.745,0,0,0,0-3.489Z",
    transform: "translate(-47.803 -5.993)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M102.577,30.075a6.873,6.873,0,1,0-13.744,0v3.489a6.873,6.873,0,1,0,13.744,0Zm-3.434,0v3.489a3.438,3.438,0,1,1-6.876,0V30.075a3.438,3.438,0,1,1,6.876,0Z",
    transform: "translate(-23.052 -5.993)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M97.341,30.624h.381a1.538,1.538,0,0,1,1.527,1.549v3.2a1.534,1.534,0,0,1-1.527,1.549h-.381a1.534,1.534,0,0,1-1.527-1.549v-3.2A1.538,1.538,0,0,1,97.341,30.624Z",
    transform: "translate(-24.864 -7.947)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M118.167,30.624h.38a1.542,1.542,0,0,1,1.527,1.549v3.2a1.538,1.538,0,0,1-1.527,1.549h-.38a1.534,1.534,0,0,1-1.528-1.549v-3.2A1.538,1.538,0,0,1,118.167,30.624Z",
    transform: "translate(-30.268 -7.947)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M139.069,30.624h.381a1.539,1.539,0,0,1,1.528,1.549v3.2a1.535,1.535,0,0,1-1.528,1.549h-.381a1.538,1.538,0,0,1-1.528-1.549v-3.2A1.542,1.542,0,0,1,139.069,30.624Z",
    transform: "translate(-35.692 -7.947)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M15.324,36.991,8.985,6.8a1.411,1.411,0,0,1,.292-1.191,1.437,1.437,0,0,1,1.115-.526h8.875a1.434,1.434,0,0,1,.857.288L15.133.418A1.447,1.447,0,0,0,14.116,0H1.437a1.438,1.438,0,0,0-1.2.641A1.421,1.421,0,0,0,.116,1.988L15.33,37.212a1.418,1.418,0,0,0,.579.652A1.417,1.417,0,0,1,15.324,36.991Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.954 5.081)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M16.1,25a1.452,1.452,0,0,1,1.117-.524h7.636a1.463,1.463,0,0,1,.6.129l28,12.625a1.437,1.437,0,0,1,.531.417,1.388,1.388,0,0,0-.13-.173L23.421,7.28A1.439,1.439,0,0,0,22.4,6.862H13.53a1.437,1.437,0,0,0-1.115.526,1.411,1.411,0,0,0-.292,1.191l3.671,17.484A1.417,1.417,0,0,1,16.1,25Z",
    transform: "translate(-12.092 -6.862)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M68.739,48.543a1.451,1.451,0,0,1,.08.13A1.3,1.3,0,0,0,68.739,48.543Z",
    transform: "translate(-26.792 -17.678)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.055,46.135a1.441,1.441,0,0,1-1.415-1.151L17.1,32.358a1.428,1.428,0,0,1,.3-1.188,1.452,1.452,0,0,1,1.117-.524h7.636a1.463,1.463,0,0,1,.6.129l28,12.626a1.43,1.43,0,0,1-.6,2.735Z",
    transform: "translate(-4.429 -7.952)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVoopter);
export default __webpack_public_path__ + "static/media/logo-voopter.7a836cd47fce41a997f6207fdfa42828.svg";
export { ForwardRef as ReactComponent };